import { useEffect, useState } from 'react'
import { useRouterWithQuery } from './useRouterWithQuery'
import { ListboxDropdownOption } from 'components/form/Home/ListboxDropdown'

export const useSort = (sortItems: ListboxDropdownOption[]) => {
  const { router, updateQueryParam, removeQueryParam } = useRouterWithQuery()
  const [internalSort, setInternalSort] = useState<ListboxDropdownOption | null>(sortItems[0])

  const setSort = (sort: ListboxDropdownOption) => {
    setInternalSort(sort)

    if (sort.value) {
      updateQueryParam('sort', sort.value)
    } else {
      removeQueryParam('sort')
    }
  }

  useEffect(() => {
    const sortValue = router.query.sort as string
    const sort = sortItems.find(item => item.value === sortValue) ?? null

    if (sort !== internalSort) {
      setInternalSort(sort)
    }
  }, [router.query.sort])

  return {
    sort: internalSort,
    setSort,
    sortItems,
  }
}
